export default __webpack_public_path__ + "static/ubuntu-v20-latin-regular-2f02effe392a63dc07a5cdf187b2ef09.woff2";